import {
    Directive,
    Input,
    OnInit,
    ViewContainerRef,
    ElementRef,
    NgModuleRef,
} from "@angular/core";
import { ObservableDataService } from "../../../services/core/observable-data.service";

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: "[ifHasPermission]",
})
export class HasPermissionDirective implements OnInit {
    @Input("ifHasPermission") permission: string;
    @Input("moduleName") moduleName: string;

    constructor(
        private _element: ElementRef,
        private _viewContainerRef: ViewContainerRef,
        private ngmodule: NgModuleRef<any>,
        private _ods: ObservableDataService
    ) {}

    ngOnInit() {
        const currentUser = this._ods.getLoggedUser();
        const { modules, isOwner, companyIsSaaSOwner } = currentUser;

        // console.log("User is owner: ", isOwner);

        // console.log(companyIsSaaSOwner);

        if (isOwner || companyIsSaaSOwner) return;

        if (!this.moduleName)
            this.moduleName = this.ngmodule.instance.moduleName;

        if (!modules[this.moduleName][this.permission]) {
            console.log("Remove element");
            this._element.nativeElement.remove();
        }
    }
}
